/* Compte a rebours et compteur de stock de la fiche produit.

   La cible du rebours arrive en epoch absolu depuis Liquid, donc le cache de
   page de Shopify ne fausse rien. Un rebours roulant (l'heure limite
   d'expedition) se reporte au jour ouvre suivant s'il est deja passe.

   Le compteur de stock, lui, suit l'inventaire reel : il relit
   /products/<handle>.js regulierement et se repeint quand le chiffre bouge.
   Il ne descend donc que si une vente a vraiment eu lieu. */
(function () {
  var JOUR = 86400000;
  var PERIODE = 45000;

  function deuxChiffres(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function prochainJourOuvre(ms) {
    var d = new Date(ms);
    // 0 = dimanche, 6 = samedi.
    while (d.getDay() === 0 || d.getDay() === 6) {
      d = new Date(d.getTime() + JOUR);
    }
    return d.getTime();
  }

  function pose(bloc, unite, valeur, visible) {
    var cell = bloc.querySelector('[data-u="' + unite + '"]');
    if (!cell) return;
    cell.hidden = !visible;
    if (visible) cell.querySelector('b').textContent = deuxChiffres(valeur);
  }

  function battement(bloc) {
    var cible = parseInt(bloc.dataset.cible, 10) * 1000;
    if (!cible) return false;

    var reste = cible - Date.now();

    if (reste <= 0 && bloc.dataset.roulant === '1') {
      while (cible <= Date.now()) cible += JOUR;
      cible = prochainJourOuvre(cible);
      bloc.dataset.cible = Math.floor(cible / 1000);
      reste = cible - Date.now();
    }

    if (reste <= 0) {
      bloc.hidden = true;
      return false;
    }

    var s = Math.floor(reste / 1000);
    var j = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);

    // Au-dela d'une journee, les secondes ne servent qu'a faire du bruit.
    pose(bloc, 'j', j, j > 0);
    pose(bloc, 'h', h, true);
    pose(bloc, 'm', m, true);
    pose(bloc, 's', s % 60, j === 0);
    return true;
  }

  function demarre(bloc) {
    if (bloc.dataset.btUrgLance === '1') return;
    bloc.dataset.btUrgLance = '1';
    if (!battement(bloc)) return;
    var id = setInterval(function () {
      if (!bloc.isConnected || !battement(bloc)) clearInterval(id);
    }, 1000);
  }

  /* --- Compteur de stock --- */

  function peindre(bloc, qte) {
    var seuil = parseInt(bloc.dataset.seuil, 10) || 40;
    var nb = bloc.querySelector('[data-nb]');
    var chip = bloc.querySelector('[data-chip]');
    var barre = bloc.querySelector('.es-urg__jauge span');
    var calcul = bloc.querySelector('[data-calcul]');

    if (qte <= 0) {
      bloc.hidden = true;
      return;
    }
    bloc.hidden = false;

    if (nb) {
      nb.innerHTML = qte === 1
        ? 'Letztes Exemplar'
        : 'Solo quedan <b>' + qte + '</b> unidades';
    }

    if (chip) {
      if (qte <= 8) {
        chip.hidden = false;
        chip.textContent = 'Kritischer Bestand';
        chip.classList.add('es-urg__chip--fort');
      } else if (qte <= 14) {
        chip.hidden = false;
        chip.textContent = 'Bald ausverkauft';
        chip.classList.remove('es-urg__chip--fort');
      } else {
        chip.hidden = true;
      }
    }

    if (barre) {
      var part = Math.round((qte * 100) / seuil);
      if (part < 8) part = 8;
      if (part > 100) part = 100;
      barre.style.width = part + '%';
    }

    if (calcul) {
      var d = Math.floor(qte / 2);
      calcul.hidden = d <= 1;
      if (d > 1) {
        calcul.textContent =
          'Límite de 2 por persona: alcanza para ' + d + ' entrenadores, ni uno más.';
      }
    }
  }

  function suivre(bloc) {
    if (bloc.dataset.btStockLance === '1') return;
    bloc.dataset.btStockLance = '1';

    var handle = bloc.dataset.handle;
    if (!handle) return;
    var vid = parseInt(bloc.dataset.variant, 10) || 0;
    var dernier = parseInt(bloc.dataset.qte, 10);

    function lire() {
      fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants || !p.variants.length) return;
          var v = null;
          for (var i = 0; i < p.variants.length; i++) {
            if (!vid || p.variants[i].id === vid) { v = p.variants[i]; break; }
          }
          if (!v || typeof v.inventory_quantity !== 'number') return;
          if (v.inventory_quantity === dernier) return;

          var baisse = v.inventory_quantity < dernier;
          dernier = v.inventory_quantity;
          bloc.dataset.qte = dernier;
          peindre(bloc, dernier);

          // Une baisse doit se voir, c'est tout l'interet d'un compteur vivant.
          if (baisse) {
            bloc.classList.remove('vient-de-baisser');
            void bloc.offsetWidth;
            bloc.classList.add('vient-de-baisser');
          }
        })
        .catch(function () {});
    }

    setInterval(lire, PERIODE);
    // Au retour sur l'onglet, on relit tout de suite plutot que d'attendre.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) lire();
    });
  }

  function balaie() {
    document.querySelectorAll('[data-es-urg]').forEach(demarre);
    document.querySelectorAll('[data-es-stock]').forEach(suivre);
  }

  balaie();
  // Minimog reinjecte la colonne produit au changement de variante.
  new MutationObserver(balaie).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();